import Lottie from "lottie-web";
import gsap from "gsap";

class Loader {
    constructor($el, onComplete = null) {
        this.$el = $el;
        this.onComplete = onComplete;
        this.json = $el.data('json');
        this.html = $('html');
        this.body = $('body');

        if (!sessionStorage.getItem('loaderCompleted')) {
            this.init();
        } else {
            this.renderStatic();
            this.html.addClass('ready');
            this.html.removeClass('no-scroll');
            this.body.removeClass('no-scroll');
            if (typeof this.onComplete === 'function') {
                this.onComplete(); 
            }

        }
    }

    init = () => {
        this.lottie = Lottie.loadAnimation({
            container: this.$el[0],
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: this.json,
        });

        const lottie = this.lottie;
        lottie.play();

        lottie.addEventListener('complete', () => {
            this.html.removeClass("no-scroll");
            this.body.removeClass('no-scroll');
            this.html.addClass("ready");
            this.$el.css('transition', 'background-color 1s');
            this.$el.removeClass("loader__bg")
            sessionStorage.setItem('loaderCompleted', 'true');

            if (typeof this.onComplete === 'function') {
                this.onComplete(); 
            }
        });
    };

    renderStatic = () => {
        this.$el.removeClass('loader__bg');
        this.$el.css({ visibility: 'hidden' });

        this.lottie = Lottie.loadAnimation({
            container: this.$el[0],
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: this.json,
        });

        const lottie = this.lottie;

        lottie.addEventListener('DOMLoaded', () => {
            const lastFrame = lottie.getDuration(true);
            lottie.goToAndStop(lastFrame, true);
            this.$el.css({ visibility: 'visible' });

        });
    };


}

export default Loader;
